module.exports = __webpack_public_path__ + "media/personas/bg-content-day-2a73a113.jpg";